import React, { useState } from 'react'

import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import PlayCircleFilledOutlinedIcon from '@mui/icons-material/PlayCircleFilledOutlined';
import KeyboardVoiceRoundedIcon from '@mui/icons-material/KeyboardVoiceRounded';
import PublicIcon from '@mui/icons-material/Public';
import LockIcon from '@mui/icons-material/Lock';
import {FaSmile} from "react-icons/fa"
import NaturePeopleIcon from '@mui/icons-material/NaturePeople';

const ProfileInputPost = ({handleSubmit,
                            setBody,
                            body,
                            images,
                            setImages,
                            profileImg,
                            modelDetails,
                            postInputBoxVisibility,
                            setPrivacyStatus
                        }) => {

  const [selectedIconPrivate,setSelectIconPrivate]=useState(false)
  const [selectedIconPublic,setSelectIconPublic]=useState(false)

  const [selectedIconTree,setSelectIconTree]=useState(false)

  const handleIconClick=function(e){
    console.log(e.nativeEvent.target.innerText)
    if(e.nativeEvent.target.innerText=="My Tree"){
      setSelectIconTree(true)
      setSelectIconPrivate(false)
      setSelectIconPublic(false)
      setPrivacyStatus("family")
    }
    else if(e.nativeEvent.target.innerText=="Private"){
      setSelectIconPrivate(true)
      setSelectIconTree(false)
      setSelectIconPublic(false)
      setPrivacyStatus("private")
    }
    else if(e.nativeEvent.target.innerText=="Public"){
      setSelectIconPublic(true)
      setSelectIconTree(false)
      setSelectIconPrivate(false)
      setPrivacyStatus("public")
    }

  }





  return (
    <div className="i-form" hidden={postInputBoxVisibility}>
        <form onSubmit={handleSubmit}>
            <div className="i-input-box">
                <img src={profileImg} className='i-img'/>
                
                <input 
                type="text" 
                id="i-input" 
                placeholder={`What's in your mind ${modelDetails.ModelName}?`}
                required
                value={body}
                onChange={(e)=>setBody(e.target.value)}
                />
            </div>

     <div className="file-upload">
      <div className="file-icons">
          <label htmlFor='file' className="pv-upload">
            <PhotoLibraryIcon className="input-svg" style={{fontSize:"38px",color:"orangered"}}/>
            <span className='photo-dis'>Photo</span>
          </label>

          <div className={selectedIconPrivate?'pv-upload selected':'pv-upload'}>
            <LockIcon  name="private" style={{fontSize:"38px",color:"red"}}/>
            <span className='photo-dis' onClick={handleIconClick}>Private</span>
          </div>
          
          <div className={selectedIconTree?'pv-upload selected':'pv-upload'}>
          <NaturePeopleIcon  name="family" style={{fontSize:"38px",color:"orange"}}/>
            <span className='photo-dis' onClick={handleIconClick}>My Tree</span>
          </div>

          <div className={selectedIconPublic?'pv-upload selected':'pv-upload'}>
            <PublicIcon  name="public" style={{fontSize:"30px",color:"green"}}/>
            <span className='photo-dis' onClick={handleIconClick}>Public</span>
          </div>
      </div>
      
          <button type='submit'>Share</button>
            
      </div>

        <div style={{display:"none"}} >
            <input 
            id='file'
            type="file" 
            accept=".png,jpeg,.jpg"
            onChange={(e)=>setImages(e.target.files[0])}
            
             />
          </div>

        {images && (
          <div className="displayImg">
            <CloseRoundedIcon onClick={()=>setImages(null)}/>
            <img src={URL.createObjectURL(images)} alt="" />
          </div>
        )}

        </form>
     </div>
  )
}

export default ProfileInputPost
